import "../../common/css/style.css";

import {
	AppBar,
	IconButton,
	MenuIcon,
	Toolbar,
	Typography,
} from "../../common/MaterialComponent";
import {
	ComponentStringsContext,
	generateComponentStringsContext,
} from "../../hooks/useGetComponentStrings";
import React, { useEffect, useState } from "react";
import {
	SessionContext,
	sessionDetailContext,
} from "../../hooks/useSessionDetail";

import Emitter from "../../common/emitter";
import Helmet from "react-helmet";
import { LanguagePicker } from "../LanguagePicker/LanguagePicker";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { NavigationDrawer } from "../NavigationDrawer/NavigationDrawer";
import { SessionDetail } from "../../common/interfaces";
import { SnackbarMessage } from "../SnackbarMessage/SnackbarMessage";
import clsx from "clsx";
import { primaryColor } from "../../common/sharedStyle";
import styles from "./App.style";
import theme from "../../themes/themes";
import {
	AuthenticatedTemplate,
	useMsal,
	useMsalAuthentication,
} from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { loginRequest } from "../../auth/authConfig";

export const App: React.FC = () => {
	const classes = styles();
	const [state, setState] = useState({
		openMenu: false,
	});

	const isClientIFRC = process.env.REACT_APP_CLIENT_NAME === "IFRC";
	const { accounts, inProgress, instance } = useMsal();
	useMsalAuthentication(InteractionType.Redirect, loginRequest);
	useEffect(() => {
		console.log("Authentication in progress:", inProgress);
	}, [accounts, inProgress, instance]);

	const toggleDrawer = (open: boolean, event: any) => {
		if (
			event.type === "keydown" &&
			((event as React.KeyboardEvent).key === "Tab" ||
				(event as React.KeyboardEvent).key === "Shift")
		) {
			return;
		}

		setState({ ...state, openMenu: open });
	};
	const [appComponentStrings, setAppComponentStrings] = useState(
		generateComponentStringsContext({ components: {} })
	);
	const sharedStrings = appComponentStrings.Shared;

	// get/set user session detail
	const [sessionDetail, setSessionDetail] = useState(
		sessionDetailContext({ accessToken: "", userInfo: undefined })
	);

	useEffect(() => {
		Emitter.on("setSessionDetail", (sessionDetail: SessionDetail) => {
			setSessionDetail(sessionDetailContext(sessionDetail));
		});
	}, []);

	const App = (
		<div>
			<Helmet>
				<title>{sharedStrings.title}</title>
				<link
					rel="icon"
					type="image/png"
					href={
						isClientIFRC
							? `${window.origin}/favicon_IFRC.ico`
							: `${window.origin}/favicon_NRC.ico`
					}
					sizes="16x16"
				/>
			</Helmet>
			<ComponentStringsContext.Provider value={appComponentStrings}>
				<SessionContext.Provider value={sessionDetail}>
					<MuiThemeProvider theme={theme}>
						<AppBar position="fixed" className={clsx(classes.appBar)}>
							<Toolbar>
								<IconButton
									color="inherit"
									aria-label="openMenu drawer"
									onClick={(event) => toggleDrawer(true, event)}
									edge="start"
									className={clsx(classes.menuButton)}
								>
									<MenuIcon color="primary" />
								</IconButton>
								<Typography
									variant="h6"
									noWrap
									className={classes.appBarHeader + " " + primaryColor}
								>
									{sharedStrings.appHeader}
								</Typography>
								<LanguagePicker
									resetAppLanguage={(data) =>
										setAppComponentStrings(
											generateComponentStringsContext(data)
										)
									}
								/>
								<img
									src={
										isClientIFRC
											? `/images/${sharedStrings.ifrcLogoUrl}`
											: `/images/${sharedStrings.nrcLogoUrl}`
									}
									alt="Logo"
									className={classes.logo}
								></img>
							</Toolbar>
						</AppBar>
						<NavigationDrawer
							openMenu={state.openMenu}
							toggleDrawer={(open: boolean, event: any) =>
								toggleDrawer(open, event)
							}
						></NavigationDrawer>
						<SnackbarMessage />
					</MuiThemeProvider>
				</SessionContext.Provider>
			</ComponentStringsContext.Provider>
		</div>
	);
	return (
		<>
			{isClientIFRC ? (
				<AuthenticatedTemplate>{App}</AuthenticatedTemplate>
			) : (
				App
			)}
		</>
	);
};
